<div class="container">
    <div class="row">
        <div class="col-lg-2 col-sm-12 col-12">
            <br />
            <img src="{{DanhMucUngDungService.FormData.FileName}}" class=""
                style="display: block; margin-left: auto; margin-right: auto; width: 50%;" />
        </div>
        <div class="col-lg-10 col-sm-12 col-12">
            <br />
            <h3 class="text-center mt-3" style="color: #208e1e;"><b>CỔNG TRUY XUẤT NGUỒN GỐC SÂM CỦ NGỌC LINH QUẢNG NAM</b></h3>
            <a title="Đăng nhập để khai báo thông tin" target="_blank" href="{{DanhMucUngDungService.FormData.Code}}">
                <h5 class="text-center" style="color: #30897f;">Đăng nhập để khai báo thông tin</h5>
            </a>
        </div>
    </div>
    <hr />
    <div class="row">
        <div class="badge bg-primary-subtle border border-primary-subtle rounded-pill" style="padding-top: 10px;">
            <h6 class="text-center" style="color: #000000;">Hàng hóa:
                <b>{{LoHangService.FormData.DanhMucSanPhamName}}</b>
            </h6>
        </div>
    </div>
    <br />
    <div class="row">
        <div class="badge bg-success-subtle border border-success-subtle rounded-pill" style="padding-top: 10px;">
            <h6 class="text-center" style="color: #000000;"><b>{{LoHangService.FormData.ParentName}}</b></h6>
        </div>
    </div>
    <br />
    <div class="row">
        <div style="overflow-x: auto; white-space: nowrap;">
            <div class="col-lg-2 col-sm-3 col-3" style="margin-bottom: 10px; display: inline-block; width: auto;"
                *ngFor="let LoHangTapTinDinhKem of LoHangTapTinDinhKemService.List001;">
                <img style="cursor: pointer; max-height: 240px;min-height: 240px;height: 240px;" (click)="LoHangTapTinDinhKemAdd(LoHangTapTinDinhKem.ID)"
                    src="{{LoHangTapTinDinhKem.FileName}}" class="img-thumbnail" />
            </div>
        </div>
        <!-- <div class="col-lg-2 col-sm-3 col-3" style="margin-bottom: 10px;"
            *ngFor="let LoHangTapTinDinhKem of LoHangTapTinDinhKemService.List001;">
            <img style="cursor: pointer; max-height: 200px;height: 200px;" (click)="LoHangTapTinDinhKemAdd(LoHangTapTinDinhKem.ID)"
                src="{{LoHangTapTinDinhKem.FileName}}" class="img-thumbnail" />
        </div> -->
    </div>
    <div class="row">
        <div class="badge bg-info-subtle border border-info-subtle rounded-pill" style="padding-top: 10px;">
            <h5 class="text-center" style="color: #000000;">Mã số truy vết sản phẩm:
                <b *ngIf="showMaso" >{{TemPhieuService.FormData.MaSo}}</b>
                <b *ngIf="!showMaso" >Đang tải</b>
            </h5>
        </div>
    </div>
    <br />
    <div class="row">
        <div class="badge bg-info-subtle border border-info-subtle rounded-pill" style="padding-top: 10px;">
            <h5 class="text-center" style="color: #000000;">Mã QR
            </h5>
        </div>
    </div>
    <div class="row">
        <div class="badge" style="padding-top: 10px;">
            <img [src]="TemPhieuService.FormData.URLQRCode" alt="QR Code" class="code-image">
        </div>
    </div>
    <br />
    <div class="row bg-success" style="color: #ffffff; padding: 10px;" *ngIf="IsPheDuyet">
        <!-- <div class="col-lg-2 col-sm-12 col-12">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor"
                class="bi bi-clipboard-check" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                    d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                <path
                    d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z" />
                <path
                    d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z" />
            </svg>
        </div> -->
        <div class="col-lg-12 col-sm-12 col-12">
            <div class="col-lg-12 col-sm-12 col-12">
                <h6>Hàng hóa đã được kiểm tra phát hành mã truy xuất nguồn gốc của Cơ Quan Quản Lý</h6>
                <h6>Được kiểm duyệt bởi: <b>{{DanhMucUngDungService.FormData.Display}}</b></h6>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <h6>Phụ trách kiểm duyệt: <b>{{LoHangService.FormData.ThanhVienNamePheDuyet}}</b></h6>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <h6>Ngày duyệt: <b>{{LoHangService.FormData.PheDuyet |
                        date:'dd/MM/yyyy'}}</b></h6>
            </div>
        </div>
    </div>
    <div class="row bg-warning" style="color: #ffffff; padding: 10px;" *ngIf="IsHetHanSuDung">
        <!-- <div class="col-lg-2 col-sm-12 col-12">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor"
                class="bi bi-clipboard-x" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                    d="M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708" />
                <path
                    d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z" />
                <path
                    d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z" />
            </svg>
        </div> -->
        <div class="col-lg-12 col-sm-12 col-12">
            <div class="col-lg-12 col-sm-12 col-12">
                <h6>Hàng hóa hết hạn sử dụng.</h6>
                <h6>Được kiểm duyệt bởi: <b>{{DanhMucUngDungService.FormData.Display}}</b></h6>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <h6>Phụ trách kiểm duyệt: <b>{{LoHangService.FormData.ThanhVienNamePheDuyet}}</b></h6>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <h6>Ngày duyệt: <b>{{LoHangService.FormData.PheDuyet |
                        date:'dd/MM/yyyy'}}</b></h6>
            </div>
        </div>
    </div>
    <div class="row bg-danger" style="color: #ffffff; padding: 10px;" *ngIf="IsThuHoi">
        <!-- <div class="col-lg-2 col-sm-12 col-12">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi bi-trash"
                viewBox="0 0 16 16">
                <path
                    d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                <path
                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
            </svg>
        </div> -->
        <div class="col-lg-12 col-sm-12 col-12">
            <div class="col-lg-12 col-sm-12 col-12">
                <h6>Hàng hóa bị thu hồi.</h6>
                <h6>Được kiểm duyệt bởi: <b>{{DanhMucUngDungService.FormData.Display}}</b></h6>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <h6>Phụ trách kiểm duyệt: <b>{{LoHangService.FormData.ThanhVienNameThuHoi}}</b></h6>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <h6>Ngày duyệt: <b>{{LoHangService.FormData.ThuHoi |
                        date:'dd/MM/yyyy'}}</b></h6>
            </div>
        </div>
    </div>
    <div class="row bg-warning" style="color: red; padding: 10px; padding-top: 15px;" *ngIf="IsChuY">
        <!-- <div class="col-lg-2 col-sm-12 col-12">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor"
                class="bi bi-clipboard-pulse" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                    d="M10 1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-5 0A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5zm-2 0h1v1H3a1 1 0 0 0-1 1V14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3.5a1 1 0 0 0-1-1h-1v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2m6.979 3.856a.5.5 0 0 0-.968.04L7.92 10.49l-.94-3.135a.5.5 0 0 0-.895-.133L4.232 10H3.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 .416-.223l1.41-2.115 1.195 3.982a.5.5 0 0 0 .968-.04L9.58 7.51l.94 3.135A.5.5 0 0 0 11 11h1.5a.5.5 0 0 0 0-1h-1.128z" />
            </svg>
        </div> -->
        <div class="col-lg-12 col-sm-12 col-12">
            <div class="col-lg-12 col-sm-12 col-12">
                <h6>Hàng hóa đang kiểm tra hoạt động truy xuất nguồn gốc, chưa được phê duyệt bởi Cơ quan quản lý.</h6>
                <h6>Đơn vị kiểm tra: <b>{{DanhMucUngDungService.FormData.Display}}</b></h6>
            </div>
        </div>
    </div>
    <div class="row" style="padding: 10px 0">
        <div class="col-lg-4 col-sm-12 col-12" style="margin-bottom: 5px;">
            <div class="bg-success text-center" style="font-weight: bold; color: #ffffff; padding: 10px;">
                Số lần quét: {{TemPhieuService.FormData.SoLanKiemTra}} (lần)
            </div>
        </div>
        <div class="col-lg-4 col-sm-12 col-12" style="margin-bottom: 5px;">
            <div (click)="ToChucAdd(0)" class="bg-primary text-center"
                style="font-weight: bold; color: #ffffff; padding: 10px; cursor: pointer;">
                Liên hệ trực tiếp đến Nhà Cung Cấp
            </div>
        </div>
        <div class="col-lg-4 col-sm-12 col-12" style="margin-bottom: 5px;">
            <div (click)="LoHangPhanAnhAdd(0)" class="bg-danger text-center"
                style="font-weight: bold; color: #ffffff; padding: 10px; cursor: pointer;">
                Phản ánh về chất lượng Hàng hóa
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasTongHopData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-success text-light" style="cursor: pointer;"
            (click)="ChangeIsTongHop()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Thông tin tổng hợp
            </h5>
        </div>
        <div class="row" style="padding-top: 10px;" *ngIf="IsTongHop">
            <div class="col-lg-12 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12">
                    <p style="color: #00ea1b; font-family: Arial, sans-serif; ">
                        Dữ liệu đã được Blockchain: <a 
                                                            (click)="gotoTrans(LoHangService.FormData.Display)"
                                                            style="cursor: pointer;
                                                            text-decoration: none;
                                                            color: #00ea1b;
                                                            display: block;
                                                            word-break: break-all;">
                                                            {{ LoHangService.FormData.Display }}
                                                        </a>
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.Name">
                    <p>Lô Hàng hóa:
                        <b>{{LoHangService.FormData.Name}}</b>                        
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.MaHoSo">
                    <p>Mã hồ sơ:
                        <b>{{LoHangService.FormData.MaHoSo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.CreatedMembershipName">
                    <p>Người tạo:
                        <b>{{LoHangService.FormData.CreatedMembershipName}}</b>
                    </p>
                </div>
                
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.ThanhVienNamePheDuyet">
                    <p>Người duyệt:
                        <b>{{LoHangService.FormData.ThanhVienNamePheDuyet}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.DanhMucSanPhamName">
                    <p>Hàng hóa:
                        <b>{{LoHangService.FormData.DanhMucSanPhamName}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamNhaCungCap">
                    <p>Nhà sản xuất:
                        <b>{{LoHangService.FormData.SanPhamNhaCungCap}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKyService.FormData.NgayGhiNhan && LoHangNhatKyService.FormData001.NgayGhiNhan">
                    <p>Thời gian sản xuất theo nhật ký:
                        <b>{{LoHangNhatKyService.FormData.NgayGhiNhan | date:'dd/MM/yyyy'}} - {{LoHangNhatKyService.FormData001.NgayGhiNhan | date:'dd/MM/yyyy'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.MaLoHang">
                    <p>Mã lô đóng gói hàng hóa:
                        <b>{{LoHangService.FormData.MaLoHang}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamSoLuong">
                    <p>Số lượng Hàng hóa trong lô hàng:
                        <b>{{LoHangService.FormData.SanPhamSoLuong | number:'1.0-0'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.NgaySanXuatDongGoi">
                    <p>Ngày sản xuất (đóng gói):
                        <b>{{LoHangService.FormData.NgaySanXuatDongGoi | date:'dd/MM/yyyy'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.NgayHetHanSuDung">
                    <p>Ngày hết hạn sử dụng:
                        <b>{{LoHangService.FormData.NgayHetHanSuDung | date:'dd/MM/yyyy'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12">
                    <p>Các tiêu chuẩn / chứng nhận / giấy phép đã có:
                        <!-- <b *ngIf="LoHangService.FormData.SanPhamGioiThieu">{{LoHangService.FormData.SanPhamGioiThieu}}</b>
                        <b *ngIf="LoHangService.FormData.SanPhamGioiThieu==null" style="color:darkgray;">{{NhaCungCapChuaCapNhat}}</b> -->
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12"
                    *ngFor="let LoHangTapTinDinhKem of LoHangTapTinDinhKemService.List002;">
                    <a style="cursor: pointer;" (click)="LoHangTapTinDinhKemAdd(LoHangTapTinDinhKem.ID)"
                        title="{{LoHangTapTinDinhKem.Name}}">{{LoHangTapTinDinhKem.Name}}</a>
                </div>
                <div class="col-lg-12 col-sm-12 col-12">
                    <span *ngIf="LoHangTapTinDinhKemService.List002==null"
                        style="color:darkgray;">{{NhaCungCapChuaCapNhat}}</span>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.VungNguyenLieuNameVungTrong">
                    <p>Tên vùng trồng:
                        <b>{{LoHangService.FormData.VungNguyenLieuNameVungTrong}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.VungNguyenLieuMaSoVungTrong">
                    <p>Mã số vùng trồng:
                        <b>{{LoHangService.FormData.VungNguyenLieuMaSoVungTrong}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.CoSoDongGoiMaSo">
                    <p>Mã số cơ sở đóng gói:
                        <b>{{LoHangService.FormData.CoSoDongGoiMaSo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.MaSoChiDanDiaLy">
                    <p>Mã số chỉ dẫn địa lý:
                        <b>{{LoHangService.FormData.MaSoChiDanDiaLy}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.HSCode">
                    <p>Mã HS Code:
                        <b>{{LoHangService.FormData.HSCode}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.GS1">
                    <p>Mã GS1:
                        <b>{{LoHangService.FormData.GS1}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKyService.FormData.VanChuyenGTIN">
                    <p>Mã GTIN:
                        <b>{{LoHangNhatKyService.FormData.VanChuyenGTIN}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12">
                    <p>Đơn vị đăng ký phát hành mã truy xuất nguồn gốc:</p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.Name">
                    <p>Đơn vị:
                        <b>{{ToChucService.FormData.Name}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.MaSoThue">
                    <p>Đăng ký kinh doanh:
                        <b>{{ToChucService.FormData.MaSoThue}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.DienThoai">
                    <p>Điện thoại:
                        <b>{{ToChucService.FormData.DienThoai}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.DiaChi">
                    <p>Địa chỉ:
                        <b>{{ToChucService.FormData.DiaChi}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamDienThoai">
                    <p> + Điện thoại chăm sóc khách hàng:
                        <b>{{LoHangService.FormData.SanPhamDienThoai}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamSoLuongMa">
                    <p>Số lượng mã truy xuất nguồn gốc đăng ký phát hành theo lô:
                        <b>{{LoHangService.FormData.SanPhamSoLuongMa | number:'1.0-0'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.CongBo">
                    <p>Ngày đăng ký phát hành mã truy xuất nguồn gốc:
                        <b>{{LoHangService.FormData.CongBo | date:'dd/MM/yyyy'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.PheDuyet">
                    <p>Ngày Cơ quan quản lý phê duyệt phát hành mã truy xuất nguồn gốc:
                        <b>{{LoHangService.FormData.PheDuyet | date:'dd/MM/yyyy'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.DanhMucLoaiHinhName">
                    <p>Loại hình truy xuất nguồn gốc:
                        <b>{{LoHangService.FormData.DanhMucLoaiHinhName}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.DanhMucPhuongThucSanXuatName">
                    <p>Phương thức phát hành tem truy xuất nguồn gốc:
                        <b>{{LoHangService.FormData.DanhMucPhuongThucSanXuatName}}</b>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasLoHangData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;" (click)="ChangeIsLoHang()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Lô hàng hóa
            </h5>
        </div>
        <div class="row" style="padding-top: 10px;" *ngIf="IsLoHang">
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.Name">
                    <p>Lô hàng:
                        <b>{{LoHangService.FormData.Name}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.MaLoHang">
                    <p>Mã lô đóng gói hàng hóa:
                        <b>{{LoHangService.FormData.MaLoHang}}</b>
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamSoLuong">
                    <p>Số lượng Hàng hóa của lô hàng:
                        <b>{{LoHangService.FormData.SanPhamSoLuong | number:'1.0-0'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamSoLuongMa">
                    <p>Số lượng mã truy xuất nguồn gốc đăng ký phát hành theo lô:
                        <b>{{LoHangService.FormData.SanPhamSoLuongMa | number:'1.0-0'}}</b>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasSanPhamData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;" (click)="ChangeIsSanPham()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Hàng hóa
            </h5>
        </div>
        <div class="row" style="padding-top: 10px;" *ngIf="IsSanPham">
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.Name">
                    <p>Hàng hóa:
                        <b>{{LoHangService.FormData.Name}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.MaLoHang">
                    <p>Mã GS1:
                        <b>{{LoHangService.FormData.MaLoHang}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.HSCode">
                    <p>Mã HSCode:
                        <b>{{LoHangService.FormData.HSCode}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.MaSoChiDanDiaLy">
                    <p>Mã số chỉ dẫn địa lý:
                        <b>{{LoHangService.FormData.MaSoChiDanDiaLy}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.NgaySanXuatDongGoi">
                    <p>Ngày sản xuất/ đóng gói:
                        <b>{{LoHangService.FormData.NgaySanXuatDongGoi | date:'dd/MM/yyyy'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.NgayHetHanSuDung">
                    <p>Ngày hết hạn sử dụng:
                        <b>{{LoHangService.FormData.NgayHetHanSuDung | date:'dd/MM/yyyy'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.HanSuDungPAO">
                    <p>HSD sau mở hộp PAO (tháng):
                        <b>{{LoHangService.FormData.HanSuDungPAO}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamKhoiLuong">
                    <p>Khối lượng Hàng hóa (gram):
                        <b>{{LoHangService.FormData.SanPhamKhoiLuong}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamDongGoi">
                    <p>Quy cách đóng gói (Theo bao bì):
                        <b>{{LoHangService.FormData.SanPhamDongGoi}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamBaoQuan">
                    <p>Quy cách bảo quản:
                        <b>{{LoHangService.FormData.SanPhamBaoQuan}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamLoaiHinh">
                    <p>Loại hình Hàng hóa:
                        <b>{{LoHangService.FormData.SanPhamLoaiHinh}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.GiaThapNhat">
                    <p>Giá thấp nhất (đồng):
                        <b>{{LoHangService.FormData.GiaThapNhat | number:'1.0-0'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.GiaCaoNhat">
                    <p>Giá cao nhất (đồng):
                        <b>{{LoHangService.FormData.GiaCaoNhat | number:'1.0-0'}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.CongBo">
                    <p>Ngày công bố:
                        <b>{{LoHangService.FormData.CongBo | date:'dd/MM/yyyy'}}</b>
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.DanhMucQuocGiaName">
                    <p>Xuất xứ:
                        <b>{{LoHangService.FormData.DanhMucQuocGiaName}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.DanhMucNhomSanPhamName">
                    <p>Nhóm Hàng hóa:
                        <b>{{LoHangService.FormData.DanhMucNhomSanPhamName}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.DanhMucNganhNgheName">
                    <p>Nhóm ngành nghề:
                        <b>{{LoHangService.FormData.DanhMucNganhNgheName}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.DanhMucDonViTinhName">
                    <p>Đơn vị tính:
                        <b>{{LoHangService.FormData.DanhMucDonViTinhName}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamThiTruong">
                    <p>Thị trường phân phối:
                        <b>{{LoHangService.FormData.SanPhamThiTruong}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamCanhBao">
                    <p>Thông tin khuyến cáo người dùng:
                        <b>{{LoHangService.FormData.SanPhamCanhBao}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamThanhPhan">
                    <p>Mô tả thành phần Hàng hóa (chi tiết theo hồ sơ công bố):
                        <b>{{LoHangService.FormData.SanPhamThanhPhan}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamGioiThieu">
                    <p>Giới thiệu ngắn về Hàng hóa:
                        <b>{{LoHangService.FormData.SanPhamGioiThieu}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamNhaCungCap">
                    <p>Giới thiệu ngắn về nhà cung cấp:
                        <b>{{LoHangService.FormData.SanPhamNhaCungCap}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.YouTube">
                    <p>Đường dẫn youtube về Hàng hóa:
                        <b>{{LoHangService.FormData.YouTube}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.SanPhamDienThoai">
                    <p>Điện thoại chăm sóc khách hàng:
                        <b>{{LoHangService.FormData.SanPhamDienThoai}}</b>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasNhaCungCapData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;"
            (click)="ChangeIsNhaCungCap()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Nhà cung cấp
            </h5>
        </div>
        <div class="row" style="padding-top: 10px;" *ngIf="IsNhaCungCap">
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.Name">
                    <p>Đơn vị:
                        <b>{{ToChucService.FormData.Name}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.MaSoThue">
                    <p>Đăng ký kinh doanh:
                        <b>{{ToChucService.FormData.MaSoThue}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.DienThoai">
                    <p>Điện thoại:
                        <b>{{ToChucService.FormData.DienThoai}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.DiaChi">
                    <p>Địa chỉ:
                        <b>{{ToChucService.FormData.DiaChi}}</b>
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.LienHeHoTen">
                    <p>Đại điện pháp luật:
                        <b>{{ToChucService.FormData.LienHeHoTen}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.LienHeChucDanh">
                    <p>Chức danh:
                        <b>{{ToChucService.FormData.LienHeChucDanh}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.LienHeDienThoai">
                    <p>Điện thoại:
                        <b>{{ToChucService.FormData.LienHeDienThoai}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.LienHeEmail">
                    <p>Email:
                        <b>{{ToChucService.FormData.LienHeEmail}}</b>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasVungNguyenLieuData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;"
            (click)="ChangeIsVungNguyenLieu()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Vùng nguyên liệu
            </h5>
        </div>
        <div class="row" style="padding-top: 10px;" *ngIf="IsVungNguyenLieu">            
                <div class="col-lg-6 col-sm-12 col-12">
                    <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.VungNguyenLieuGiong">
                        <p>Chuẩn loại (Giống):
                            <b>{{LoHangService.FormData.VungNguyenLieuGiong}}</b>
                        </p>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.VungNguyenLieuKhoaHoc">
                        <p>Tên khoa học:
                            <b>{{LoHangService.FormData.VungNguyenLieuKhoaHoc}}</b>
                        </p>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.VungNguyenLieuSoVu">
                        <p>Số vụ trong năm:
                            <b>{{LoHangService.FormData.VungNguyenLieuSoVu}}</b>
                        </p>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.VungNguyenLieuSanLuongTrungBinh"  >
                        <p>Sản lượng trung bình/vụ:
                            <b>{{LoHangService.FormData.VungNguyenLieuSanLuongTrungBinh | number:'1.0-0'}}</b>
                        </p>
                    </div>
                </div>
                <div class="col-lg-6 col-sm-12 col-12">
                    <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.VungNguyenLieuMaSoVungTrong">
                        <p>Danh sách mã vùng trồng:
                            <b>{{LoHangService.FormData.VungNguyenLieuMaSoVungTrong}}</b>
                        </p>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.VungNguyenLieuDienTich">
                        <p>Tổng diện tích vùng nguyên liệu:
                            <b>{{LoHangService.FormData.VungNguyenLieuDienTich | number:'1.0-0'}}</b>
                        </p>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.VungNguyenLieuTieuChuan">
                        <p>Tiêu chuẩn, chứng nhận của vùng nguyên liệu:
                            <b>{{LoHangService.FormData.VungNguyenLieuTieuChuan}}</b>
                        </p>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.VungNguyenLieuGhiChu">
                        <p>Ghi chú:
                            <b>{{LoHangService.FormData.VungNguyenLieuGhiChu}}</b>
                        </p>
                    </div>
                </div>
            
            <div class="row" *ngIf="LoHangService.FormData.DanhMucUngDungID!=5">
                OK
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasNhaMayData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;" (click)="ChangeIsNhaMay()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Nhà máy sản xuất/chế biến
            </h5>
        </div>
        <div class="row" style="padding-top: 10px;" *ngIf="IsNhaMay">
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.NhaMayCheBienName">
                    <p>Tiêu đề:
                        <b>{{LoHangService.FormData.NhaMayCheBienName}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.NhaMayCheBienMaSo">
                    <p>Mã số:
                        <b>{{LoHangService.FormData.NhaMayCheBienMaSo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.NhaMayCheBienTieuChuan">
                    <p>Tiêu chuẩn, chứng nhận của nhà máy:
                        <b>{{LoHangService.FormData.NhaMayCheBienTieuChuan}}</b>
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.NhaMayCheBienDiaChi">
                    <p>Địa chỉ:
                        <b>{{LoHangService.FormData.NhaMayCheBienDiaChi}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.NhaMayCheBienKinhDo">
                    <p>Kinh độ:
                        <b>{{LoHangService.FormData.NhaMayCheBienKinhDo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.NhaMayCheBienViDo">
                    <p>Vĩ độ:
                        <b>{{LoHangService.FormData.NhaMayCheBienViDo}}</b>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasCoSoDongGoiData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;"
            (click)="ChangeIsCoSoDongGoi()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Cơ sở đóng gói
            </h5>
        </div>
        <div class="row" style="padding-top: 10px;" *ngIf="IsCoSoDongGoi">
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.CoSoDongGoiName">
                    <p>Tiêu đề:
                        <b>{{LoHangService.FormData.CoSoDongGoiName}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.CoSoDongGoiMaSo">
                    <p>Mã số:
                        <b>{{LoHangService.FormData.CoSoDongGoiMaSo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.CoSoDongGoiGhiChu">
                    <p>Ghi chú:
                        <b>{{LoHangService.FormData.CoSoDongGoiGhiChu}}</b>
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.CoSoDongGoiDiaChi">
                    <p>Địa chỉ:
                        <b>{{LoHangService.FormData.CoSoDongGoiDiaChi}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.CoSoDongGoiKinhDo">
                    <p>Kinh độ:
                        <b>{{LoHangService.FormData.CoSoDongGoiKinhDo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.CoSoDongGoiViDo">
                    <p>Vĩ độ:
                        <b>{{LoHangService.FormData.CoSoDongGoiViDo}}</b>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasKhoLuuTruData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;"
            (click)="ChangeIsKhoLuuTru()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Kho lưu trữ
            </h5>
        </div>
        <div class="row" style="padding-top: 10px;" *ngIf="IsKhoLuuTru">
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoLuuTruName">
                    <p>Tiêu đề:
                        <b>{{LoHangService.FormData.KhoLuuTruName}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoLuuTruMaSo">
                    <p>Mã kho:
                        <b>{{LoHangService.FormData.KhoLuuTruMaSo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoLuuTruDieuKien">
                    <p>Điều kiện lưu trữ:
                        <b>{{LoHangService.FormData.KhoLuuTruDieuKien}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoLuuTruNhietDo">
                    <p>Nhiệt độ lưu trữ:
                        <b>{{LoHangService.FormData.KhoLuuTruNhietDo}}</b>
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="ToChucService.FormData.KhoLuuTruDiaChi">
                    <p>Địa chỉ:
                        <b>{{LoHangService.FormData.KhoLuuTruDiaChi}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoLuuTruKinhDo">
                    <p>Kinh độ:
                        <b>{{LoHangService.FormData.KhoLuuTruKinhDo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoLuuTruViDo">
                    <p>Vĩ độ:
                        <b>{{LoHangService.FormData.KhoLuuTruViDo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoLuuTruGhiChu">
                    <p>Ghi chú:
                        <b>{{LoHangService.FormData.KhoLuuTruGhiChu}}</b>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasKhoThuongMaiData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;"
            (click)="ChangeIsKhoThuongMai()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Kho thương mại
            </h5>
        </div>
        <div class="row" style="padding-top: 10px;" *ngIf="IsKhoThuongMai">
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoThuongMaiName">
                    <p>Tiêu đề:
                        <b>{{LoHangService.FormData.KhoThuongMaiName}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoThuongMaiMaSo">
                    <p>Mã kho:
                        <b>{{LoHangService.FormData.KhoThuongMaiMaSo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoThuongMaiDieuKien">
                    <p>Điều kiện lưu trữ:
                        <b>{{LoHangService.FormData.KhoThuongMaiDieuKien}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoThuongMaiNhietDo">
                    <p>Nhiệt độ lưu trữ:
                        <b>{{LoHangService.FormData.KhoThuongMaiNhietDo}}</b>
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoThuongMaiDiaChi">
                    <p>Địa chỉ:
                        <b>{{LoHangService.FormData.KhoThuongMaiDiaChi}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoThuongMaiKinhDo">
                    <p>Kinh độ:
                        <b>{{LoHangService.FormData.KhoThuongMaiKinhDo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoThuongMaiViDo">
                    <p>Vĩ độ:
                        <b>{{LoHangService.FormData.KhoThuongMaiViDo}}</b>
                    </p>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangService.FormData.KhoThuongMaiGhiChu">
                    <p>Ghi chú:
                        <b>{{LoHangService.FormData.KhoThuongMaiGhiChu}}</b>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasLoHangMuaBanData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;"
            (click)="ChangeIsLoHangMuaBan()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Lịch sử mua bán trao đổi
            </h5>
        </div>
        <div *ngIf="IsLoHangMuaBan">
            <div class="row" style="padding-top: 10px;" *ngFor="let LoHangMuaBan of LoHangMuaBanService.List;">
                <div class="col-lg-4 col-sm-12 col-12" *ngIf="LoHangMuaBan.NgayGhiNhan">
                    <p>Ghi nhận: <b>{{LoHangMuaBan.NgayGhiNhan |
                            date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-lg-4 col-sm-12 col-12" *ngIf="LoHangMuaBan.DanhMucPhuongThucMuaBanName">
                    <p>Phương thức: <b>{{LoHangMuaBan.DanhMucPhuongThucMuaBanName}}</b></p>
                </div>
                <div class="col-lg-4 col-sm-12 col-12" *ngIf="LoHangMuaBan.DonGia">
                    <p>Đơn giá: <b>{{LoHangMuaBan.DonGia}}</b></p>
                </div>
                <div class="col-lg-4 col-sm-12 col-12" *ngIf="LoHangMuaBan.Display">
                    <p>Đơn hàng: <b>{{LoHangMuaBan.Display}}</b></p>
                </div>
                <div class="col-lg-4 col-sm-12 col-12" *ngIf="LoHangMuaBan.Name">
                    <p>Bên mua: <b>{{LoHangMuaBan.Name}}</b></p>
                </div>
                <div class="col-lg-4 col-sm-12 col-12" *ngIf="LoHangMuaBan.DienThoai">
                    <p>Điện thoại: <b>{{LoHangMuaBan.DienThoai}}</b></p>
                </div>
                <hr />
            </div>
            <div class="row" style="padding-top: 10px;" *ngIf="LoHangMuaBanService.List.length==0">
                <span *ngIf="LoHangMuaBanService.List.length==0"
                    style="color:darkgray;">{{NhaCungCapChuaCapNhat}}</span>
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasNhatKyData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;" (click)="ChangeIsNhatKy()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Nhật ký Hàng hóa
            </h5>
        </div>
        <div *ngIf="IsNhatKy">
            <div class="row" style="padding-top: 10px;" *ngFor="let LoHangNhatKy of LoHangNhatKyService.List;">
                <h5 style="cursor: pointer;" (click)="LoHangNhatKyAdd(LoHangNhatKy)">
                    <b>{{LoHangNhatKy.Name}} - {{LoHangNhatKy.NgayGhiNhan |
                        date:'dd/MM/yyyy'}}</b>
                </h5>
                <div class="row" *ngIf="LoHangNhatKy.Active">
                    <div class="col-lg-6 col-sm-12 col-12">
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.NgayGhiNhan">
                            <p>Ghi nhận: <b>{{LoHangNhatKy.NgayGhiNhan |
                                    date:'dd/MM/yyyy'}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.DanhMucQuyTrinhName">
                            <p>Quy trình: <b>{{LoHangNhatKy.DanhMucQuyTrinhName}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.TransactionID">
                            <p>Blockchain: <b>{{LoHangNhatKy.TransactionID}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.Name">
                            <p>Nhật ký: <b>{{LoHangNhatKy.Name}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.NguoiPhuTrach">
                            <p>Người phụ trách: <b>{{LoHangNhatKy.NguoiPhuTrach}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.CoSoDongGoiName">
                            <p>Cơ sở đóng gói: <b>{{LoHangNhatKy.CoSoDongGoiName}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.CoSoDongGoiMaSo">
                            <p>Mã số Cơ sở đóng gói: <b>{{LoHangNhatKy.CoSoDongGoiMaSo}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VungTrongName">
                            <p>Vùng trồng: <b>{{LoHangNhatKy.VungTrongName}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VungTrongMaSo">
                            <p>Mã số Vùng trồng: <b>{{LoHangNhatKy.VungTrongMaSo}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VatTuName">
                            <p>Vật tư: <b>{{LoHangNhatKy.VatTuName}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VatTuDonViTinh">
                            <p>Đơn vị tính: <b>{{LoHangNhatKy.VatTuDonViTinh}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VatTuSoLuong">
                            <p>Số lượng/liều lượng sử dụng: <b>{{LoHangNhatKy.VatTuSoLuong |
                                    number:'1.0-0'}}</b></p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-sm-12 col-12">
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VanChuyenName">
                            <p>Đơn vị vận chuyển: <b>{{LoHangNhatKy.VanChuyenName}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VanChuyenPhuongThuc">
                            <p>Phương thức vận chuyển: <b>{{LoHangNhatKy.VanChuyenPhuongThuc}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VanChuyenLoaiHinh">
                            <p>Loại hình vận chuyển: <b>{{LoHangNhatKy.VanChuyenLoaiHinh}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VanChuyenSoHieu">
                            <p>Biển số xe: <b>{{LoHangNhatKy.VanChuyenSoHieu}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VanChuyenKhoiHanh">
                            <p>Điểm khởi hành: <b>{{LoHangNhatKy.VanChuyenKhoiHanh}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VanChuyenDiemDen">
                            <p>Điểm đến: <b>{{LoHangNhatKy.VanChuyenDiemDen}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VanChuyenMaVanDon">
                            <p>Mã vận đơn: <b>{{LoHangNhatKy.VanChuyenMaVanDon}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.VanChuyenGTIN">
                            <p>Mã GTIN: <b>{{LoHangNhatKy.VanChuyenGTIN}}</b></p>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangNhatKy.Note">
                            <p>Mô tả ngắn hoạt động: <b>{{LoHangNhatKy.Note}}</b></p>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
            <div class="row" style="padding-top: 10px;" *ngIf="LoHangNhatKyService.List.length==0">
                <span *ngIf="LoHangNhatKyService.List.length==0"
                    style="color:darkgray;">{{NhaCungCapChuaCapNhat}}</span>
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;" *ngIf="hasTapTinData()">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;" (click)="ChangeIsTapTin()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Tập tin đính kèm
            </h5>
        </div>
        <div class="row" style="padding-top: 10px;" *ngIf="IsTapTin">
            <div class="col-lg-12 col-sm-12 col-12"
                *ngFor="let DanhMucTapTinDinhKemPhanLoai of DanhMucTapTinDinhKemPhanLoaiService.List;">
                <h5 style="cursor: pointer;" (click)="DanhMucTapTinDinhKemPhanLoaiAdd(DanhMucTapTinDinhKemPhanLoai)">
                    <b>{{DanhMucTapTinDinhKemPhanLoai.Name}}</b>
                </h5>
                <div class="row" *ngIf="DanhMucTapTinDinhKemPhanLoai.Active">
                    <div class="col-lg-6 col-sm-6 col-6"
                        *ngFor="let LoHangTapTinDinhKem of LoHangTapTinDinhKemService.ListFilter;">
                        <img style="cursor: pointer;" (click)="LoHangTapTinDinhKemAdd(LoHangTapTinDinhKem.ID)"
                            class="img-thumbnail" src="{{LoHangTapTinDinhKem.FileName}}" />
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12" *ngIf="LoHangTapTinDinhKemService.ListFilter.length==0">
                        <span *ngIf="LoHangTapTinDinhKemService.ListFilter.length==0"
                            style="color:darkgray;">{{NhaCungCapChuaCapNhat}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px;">
        <div class="col-lg-12 col-sm-12 col-12 bg-info text-light" style="cursor: pointer;" (click)="ChangeIsMap()">
            <h5 style="padding: 5px; padding-top: 12px;">
                Xem bản đồ số
            </h5>
        </div>
        <div class="row" style="padding-top: 10px;" *ngIf="IsMap">
            <div class="col-lg-12 col-sm-12 col-12">
                <a style="cursor: pointer; color: chocolate;" title="Xem bản đồ số" (click)="MapLoad(0)">
                    <b>Xem bản đồ số</b>
                </a>
                |
                <a style="cursor: pointer;" title="Vùng nguyên liệu" (click)="MapLoad(4)">
                    Vùng nguyên liệu
                </a>
                |
                <a style="cursor: pointer;" title="Tuyến đường vận chuyển" (click)="MapLoad(1)">
                    Tuyến đường vận chuyển
                </a>
                |
                <a style="cursor: pointer;" title="Nhà máy sản xuất/Chế bến và Kho" (click)="MapLoad(2)">
                    Nhà máy sản xuất/Chế bến và Kho
                </a>
                |
                <a style="cursor: pointer;" title="Địa điểm bán hàng" (click)="MapLoad(3)">
                    Địa điểm bán hàng
                </a>
            </div>
            <br />
            <br />
            <div class="col-lg-12 col-sm-12 col-12">
                <div class="map" #map style="height: 600px; width: 100%;">
                    <div style="z-index: 1000; position: absolute; top: 0;">
                        <img src="assets/image/vungtrong.png" />
                    </div>
                    <div
                        style="z-index: 1000; position: absolute; bottom: 0; width: 100%; height: 20px; background-color: #ffffff;">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr />
    <div class="row">
        <div class="col-lg-12 col-sm-12 col-12">
            <h5 class="text-center"><b>Bình chọn Hàng hóa</b></h5>
        </div>
        <div class="col-lg-2 col-sm-4 col-4">
            <img (click)="LoHangBinhChonAdd(20)" class="img-thumbnail" src="assets/image/sen20.png" title="20%"
                [style]="CSSLoHangBinhChon20" />
            <h5 class="text-center"><b>20%</b></h5>
        </div>
        <div class="col-lg-2 col-sm-4 col-4">
            <img (click)="LoHangBinhChonAdd(40)" class="img-thumbnail" src="assets/image/sen40.png" title="40%"
                [style]="CSSLoHangBinhChon40" />
            <h5 class="text-center"><b>40%</b></h5>
        </div>
        <div class="col-lg-2 col-sm-4 col-4">
            <img (click)="LoHangBinhChonAdd(60)" class="img-thumbnail" src="assets/image/sen60.png" title="60%"
                [style]="CSSLoHangBinhChon60" />
            <h5 class="text-center"><b>60%</b></h5>
        </div>
        <div class="col-lg-2 col-sm-4 col-4">
            <img (click)="LoHangBinhChonAdd(80)" class="img-thumbnail" src="assets/image/sen80.png" title="80%"
                [style]="CSSLoHangBinhChon80" />
            <h5 class="text-center"><b>80%</b></h5>
        </div>
        <div class="col-lg-2 col-sm-4 col-4">
            <img (click)="LoHangBinhChonAdd(100)" class="img-thumbnail" src="assets/image/sen100.png" title="100%"
                [style]="CSSLoHangBinhChon100" />
            <h5 class="text-center"><b>100%</b></h5>
        </div>
        <div class="col-lg-2 col-sm-4 col-4">
            <img (click)="LoHangBinhChonAdd(200)" class="img-thumbnail" src="assets/image/sen200.png" title="100%"
                [style]="CSSLoHangBinhChon200" />
            <h5 class="text-center"><b>200%</b></h5>
        </div>
    </div>
    <hr />
    <div class="row"
        style="border-color: #e4e4e4; border-style: solid; border-width: 1px; margin: 0px; padding-bottom: 20px;">
        <div class="col-lg-12 col-sm-12 col-12 bg-primary text-light" style="cursor: pointer;">
            <h5 class="text-center" style="padding: 5px; padding-top: 12px;">
                Tra cứu Mã Truy Xuất Nguồn Gốc Hàng Hóa
            </h5>
        </div>
        <div class="col-lg-4 col-sm-12 col-12">
            <br />
            <div class="form-group">
                <input name="MaSo" [(ngModel)]="TemPhieuService.BaseParameter.MaSo"
                    placeholder="Nhập Mã số truy vết sản phẩm ..." type="text" class="form-control">
            </div>
            <br />
            <div class="form-group">
                <a (click)="TemPhieuSearch001()" style="width: 100%; color: #ffffff;" title="Mã số truy vết sản phẩm"
                    class="btn btn-primary"><i class="bi bi-search"></i> Tra cứu Mã số truy vết sản phẩm</a>
            </div>
        </div>
        <div class="col-lg-4 col-sm-12 col-12">
            <br />
            <div class="form-group">
                <input name="VanChuyenGTIN" [(ngModel)]="TemPhieuService.BaseParameter.VanChuyenGTIN"
                    placeholder="Nhập Mã GTIN ..." type="text" class="form-control">
            </div>
            <br />
            <div class="form-group">
                <a (click)="TemPhieuSearch002()" style="width: 100%; color: #ffffff;" title="Mã GTIN"
                    class="btn btn-primary"><i class="bi bi-search"></i> Tra cứu Mã GTIN</a>
            </div>
        </div>
        <div class="col-lg-4 col-sm-12 col-12">
            <br />
            <div class="form-group">
                <input name="MaLoHang" [(ngModel)]="TemPhieuService.BaseParameter.MaLoHang"
                    placeholder="Nhập Mã lô đóng gói hàng hóa ..." type="text" class="form-control">
            </div>
            <br />
            <div class="form-group">
                <a (click)="TemPhieuSearch003()" style="width: 100%; color: #ffffff;" title="Mã lô đóng gói hàng hóa"
                    class="btn btn-primary"><i class="bi bi-search"></i> Tra cứu Mã lô đóng gói hàng hóa</a>
            </div>
        </div>
    </div>
</div>
<footer class="bg-success" style="padding: 10px; padding-top: 20px;">
    <h6 class="text-center text-light">SỞ KHOA HỌC VÀ CÔNG NGHỆ Thành Phố Đà Nẵng
Đề tài KHCN "Xây dựng cơ sở dữ liệu vùng sâm và ứng dụng công nghệ Blockchain trong quản lý, kiểm soát, truy xuất nguồn gốc, chất lượng, quảng bá và thương mại hoá chuỗi sản phẩm sâm củ Ngọc Linh"
    </h6>
</footer>

<div style="position: fixed; bottom: 160px; right: 10px;">
    <a href="{{URLVN}}" target="_blank"><img class="img-thumbnail" src="assets/image/vn.png" width="45" height="30"
            style="margin-bottom: 5px;" /></a>
    <br />
    <a href="{{URLCN}}" target="_blank"><img class="img-thumbnail" src="assets/image/cn.png" width="45" height="30"
            style="margin-bottom: 5px;" /></a>
    <br />
    <a href="{{URLEN}}" target="_blank"><img class="img-thumbnail" src="assets/image/en.png" width="45" height="30"
            style="margin-bottom: 5px;" /></a>
    <br />
    <a href="{{URLJP}}" target="_blank"><img class="img-thumbnail" src="assets/image/jp.png" width="45" height="30"
            style="margin-bottom: 5px;" /></a>
    <br />
    <a href="{{URLKR}}" target="_blank"><img class="img-thumbnail" src="assets/image/kr.png" width="45" height="30"
            style="margin-bottom: 5px;" /></a>
    <br />
    <a href="{{URLFR}}" target="_blank"><img class="img-thumbnail" src="assets/image/fr.png" width="45" height="30"
            style="margin-bottom: 5px;" /></a>
</div>

<app-loading *ngIf="TemPhieuService.IsShowLoading"></app-loading>